import { render, staticRenderFns } from "./loyalty-progress.vue?vue&type=template&id=5f2fe41c&scoped=true&"
import script from "./loyalty-progress.ts?vue&type=script&lang=ts&"
export * from "./loyalty-progress.ts?vue&type=script&lang=ts&"
import style0 from "./loyalty-progress.scss?vue&type=style&index=0&id=5f2fe41c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2fe41c",
  null
  
)

component.options.__file = "loyalty-progress.vue"
export default component.exports